// src/pages/QuestionReviewPage.jsx
import React, { useState, useEffect } from 'react';
import QuestionEditor from '../components/QuestionEditor'; // 🌟 Reusing your component!
import './ReviewQueuePage.css';
import api from '../api/axiosConfig';
import QuestionPreview from '../components/QuestionPreview';

export default function QuestionReviewPage() {
    const [queue, setQueue] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [submitting, setSubmitting] = useState(false);


    const activeQuestion = queue[currentIndex];
    console.log("Active Question for Review:", activeQuestion);

    const [previewQuestion, setPreviewQuestion] = useState(activeQuestion);

    useEffect(() => {
        setPreviewQuestion(activeQuestion);
    }, [activeQuestion]);

    const fetchReviewQueue = async () => {
        try {
            const response = await api.get('/admin/questions/review-queue');
            setQueue(response.data);
        } catch (error) {
            console.error("Error fetching review queue:", error);
        }
    };

    useEffect(() => {
        fetchReviewQueue();
    }, []);

    const handleReviewAction = async () => {
        if (queue.length === 0) return;
        setSubmitting(true);
        try {

            // 2. Advance the layout slide track to the next item
            if (currentIndex < queue.length - 1) {
                setCurrentIndex(prev => prev + 1);
            } else {
                // If we processed the last item, reset or refresh queue array frame
                setQueue([]);
                fetchReviewQueue(); // Optionally refresh the queue from the server
            }
        } catch (err) {
            console.error("Review action error:", err);
            alert("Error saving evaluation steps. Please retry.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="review-layout-wrapper">
            {/* 🌟 Dedicated Portal Admin Header (Replacing global component dependency) */}
            <header className="admin-header">
                <div className="header-titles">
                    <h1>Question Review Queue</h1>
                </div>
            </header>

            <main className="review-workspace-container">
                {/* Status Hub Banner Bar */}
                <header className="review-header-bar">
                    <div className="queue-metric-pill">
                        <span>Review Queue Dashboard</span>
                        <strong className="count-badge">
                            {queue.length > 0 ? `${currentIndex + 1} / ${queue.length}` : '0 / 0'}
                        </strong>
                    </div>
                    {queue.length > 0 && (
                        <button
                            className="skip-action-btn"
                            disabled={submitting || currentIndex >= queue.length - 1}
                            onClick={() => setCurrentIndex(prev => prev + 1)}
                        >
                            Skip For Now
                        </button>
                    )}
                </header>

                {queue.length === 0 ? (
                    <div className="empty-queue-card">
                        <span className="success-check-icon">🎉</span>
                        <h2>Review Queue Clear!</h2>
                        <p>All database question components are currently approved and active live.</p>
                    </div>
                ) : (
                    <div className={`editor-injection-zone ${submitting ? 'is-syncing' : ''}`}>
                        {/* Reusing your standalone editor component layout asset */}
                        <div class="review-container">
                            {previewQuestion && <QuestionPreview data={previewQuestion} />}
                            <QuestionEditor
                                key={activeQuestion.id} // Forces complete re-render when changing indices
                                question={activeQuestion}
                                onSave={() => handleReviewAction()}
                                inReview={true}
                                onChange={setPreviewQuestion}
                            />   
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}